import { render, staticRenderFns } from "./CargaMasiva.vue?vue&type=template&id=1650a5e0&"
import script from "./CargaMasiva.vue?vue&type=script&lang=js&"
export * from "./CargaMasiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports